import React from 'react';
import PropTypes from 'prop-types';

import PhotoForegroundUpdate from './PhotoForegroundUpdate';
import withModal from '../modal/withModal';

export const PHOTO_FOREGROUND_UPDATE_MODAL = 'MODAL/PHOTO_FOREGROUND_UPDATE';

const propTypes = {
  actionProps: PropTypes.shape({
    photo: PropTypes.shape({
      id: PropTypes.string,
      foreground: PropTypes.shape({
        original_url: PropTypes.string,
      }),
    }),
  }),
};

const PhotoForegroundUpdateModal = ({ actionProps, ...props }) => {
  const { photo } = actionProps ?? {};
  return <PhotoForegroundUpdate photo={photo} {...props} />;
};

PhotoForegroundUpdateModal.propTypes = propTypes;

export default withModal(PhotoForegroundUpdateModal, {
  name: PHOTO_FOREGROUND_UPDATE_MODAL,
  size: 'md',
  type: 'full',
});
